import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SideBarState } from '@app/views/themes/default-theme/models';

@Injectable({
	providedIn: 'root'
})
export class NavigationService { 

	// for toggle sidebar from other components
	private toggleSidebar = new Subject<SideBarState>();

	public toggleSidebar$ = this.toggleSidebar.asObservable();
	constructor() { }

	public toggleSideBar(state: SideBarState): void {
		this.toggleSidebar.next(state);
	}

}
